import React from "react";
import PropTypes from "prop-types";

import { isEmbeddedElement } from "utils/pageElements/helpers";

import Typography from "@mui/material/Typography";

const Title = ({ type }) => {

  const isEmbedded = isEmbeddedElement(type);

  const getTitle = () => {
    if (isEmbedded) return "Embed";
    if (type === "title") return "Header";
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  return (
    <Typography variant="body2" sx={{ fontWeight: 700 }}>
      {getTitle()}
    </Typography>
  );
};

Title.propTypes = {
  type: PropTypes.string.isRequired,
};

export default Title;
